import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAHMwxx2dO4FwvJbEqx6m2g2FQFEX36SBo",
  authDomain: "amoozeshmelli-mono.firebaseapp.com",
  projectId: "amoozeshmelli-mono",
  storageBucket: "amoozeshmelli-mono.firebasestorage.app",
  messagingSenderId: "1085607323957",
  appId: "1:1085607323957:web:676f913de168b6ee04447c",
  measurementId: "G-KYHNG5C8VZ"
};

// Initialize Firebase
initializeApp(firebaseConfig);

const messaging = getMessaging();
export const requestForToken = async () => {
  return getToken(messaging, {
    vapidKey:
      "BBD3q6BvkRYs889Lkk_c_qQFnh_ONknuW7gGnKXBgx4ddLTkqAE-T9pwLu2QgA3rcD1WKMZUFGHOMKcLdo2Ur5M",
  })
      .then((currentToken) => {
        if (currentToken) {
          console.log("current token for client: ", currentToken);
          localStorage.setItem(
              "amoozeshMeliFirebaseToken",
              JSON.stringify(currentToken)
          );
          // Perform any other neccessary action with the token
        } else {
          // Show permission request UI
          console.log(
              "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });
};

////
////
export const onMessageListener = () =>
    new Promise((resolve) => {
      onMessage(messaging, (payload) => {
        console.log("payload", payload);
        resolve(payload);
      });
    });
